import React from "react";
import { Bar } from 'react-chartjs-2';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

  import "chartjs-plugin-datalabels";
  import {
    Chart as ChartJS,
    CategoryScale,
    
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from "chart.js";
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import 'chart.js/auto';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels // Register the DataLabels plugin
  );
  

  const StackedBarChartPolicies = (props) => {
const { t } = useTranslation();
    
  const options = {
  responsive: true,
   maintainAspectRatio: false,
   layout: {
      padding: {
        top: 22,
        right: 22,
        left: 22
      }
    },
   scales: {
    x: {
      
        stacked: true
    },
          y: {
        stacked: true,
        title: {
          display: true,
          text:t(props.titleY),
        
           color: "rgb(84, 84, 84)", 
            font: {
              size: 13,
              weight: "500",
            },
          padding: {top: 30, left: 0, right: 0, bottom: 0}
        }
      }
    },
  plugins: {
    legend: {
      display: true,
            onClick: null,
      position: "bottom"
    },
    tooltip: {
        callbacks: {
          title: function(context) {
            let title = context[0].label.replace(/[ ,.]/g,' ');
            return title;
      } 
    }
},
    title: {
      display: true,
        align:'center',
        text: props.titleX,
      position:'bottom',
       color: "rgb(84, 84, 84)", 
            font: {
              size: 14,
              weight: "500",
            },
    },
      datalabels: {
          display: false
  },
},

  };

 // const edited
  const fullLabels = [ 
  t("region_africa").split(" "), 
  t("region_asia").split(" "),
  t("region_europe").split(" "), 
  t("region_lac").split(" "),
  t("region_neareast").split(" "),
  t("region_north_america").split(" "),
  t("region_swpacific").split(" ")];

  const mobileLabels = ['AF', "AS", "EU", "LAC", "NE", "NA", ]

  const fullNamesRegions = [ 
  t("region_africa"), 
  t("region_asia"),
  t("region_europe"), 
  t("region_lac"),
  t("region_neareast"),
  t("region_north_america"),
  t("region_swpacific")];
  const labels = props.size.x > 600  ? fullLabels : mobileLabels;
const dataSet = {
  labels,
  datasets: [
    {
    label: t('graphs_legend_yes'),
      data: [props.data[0][0],
              props.data[1][0], 
              props.data[2][0], 
              props.data[3][0],
              props.data[4][0],
              props.data[5][0], 
              props.data[6][0]],
      backgroundColor: "rgb(138, 206, 126)",
    },
    {
    label:  t('legend_initiated'),
      data:  [props.data[0][1],
              props.data[1][1], 
              props.data[2][1], 
              props.data[3][1],
              props.data[4][1],
              props.data[5][1], 
              props.data[6][1]],
      backgroundColor: "rgb(240, 189, 39)",
    },
    {
    label:  t('legend_no'),
      data:  [props.data[0][2],
              props.data[1][2], 
              props.data[2][2], 
              props.data[3][2],
              props.data[4][2],
              props.data[5][2], 
              props.data[6][2]],
      backgroundColor: "rgb(225, 53, 49)",
    },
    {
    label:  t('graphs_legend_no_info'),
      data:   [props.data[0][3],
              props.data[1][3], 
              props.data[2][3], 
              props.data[3][3],
              props.data[4][3],
              props.data[5][3], 
              props.data[6][3]],
      backgroundColor: "rgb(92, 96, 104)",
    },
  ],
};
    return (
      <div >

      <Card>
      <Card.Header><p className="card-title">{t(props.graphTitle)}</p></Card.Header>
      <Card.Body> 
        <div className={props.isSubquestion ? "graph-div-subquestion" : "graph-div-main"}>
         <Bar options={options} data={dataSet} className="graph-height-mobile"/>
          <div className="mobile-legend">
         {mobileLabels.map((acr, index) => 
           <p key={acr+index}style={{fontSize: "10px", margin: "0px"}}>{acr + ": " + fullNamesRegions[index]}</p>
          )}
         </div>
         </div>
       </Card.Body>
    </Card> 


   
      </div>
    );
  };
  
  export default StackedBarChartPolicies;
  
